import React from 'react';
import history from 'dashboard/history';
import BrowserMenu from 'components/BrowserMenu/BrowserMenu.react';
import MenuItem from 'components/BrowserMenu/MenuItem.react';
import Separator from 'components/BrowserMenu/Separator.react';
import styles from 'dashboard/Data/Browser/Browser.scss';
import Toolbar from 'components/Toolbar/Toolbar.react';
import BrowserToolbarButton from 'components/BrowserToolbarButton/BrowserToolbarButton.react';
import Breadcrumbs, { combineResolvers, textResolver, resolver, key, childOf, pathname, path } from 'react-router-breadcrumbs';

import CDNstyles from './CDN.scss';


const CDNSiteToolbar = (props) => {
  const REPORTS = (
    <BrowserMenu title="Reports" icon="icon-area-chart">
      <MenuItem
        text="Hourly Breakdown"
        onClick={() => {}} />
      <MenuItem
        text="Top 50 Files"
        onClick={() => {}} />
      {
        // <MenuItem
        //   text='File Types'
        //   onClick={() => {}}
        // />
      }
      <MenuItem
        text="Status Codes"
        onClick={() => {}} />
      <MenuItem
        text="Edge Locations"
        onClick={() => {}} />
      <MenuItem
        text="Logs"
        onClick={() => {}} />
      {
        // <MenuItem
        //   text='Daily Files'
        //   onClick={() => {}}
        // />
      }
    </BrowserMenu>
  );

  const SETTINGS = (
    <BrowserMenu title="Settings" icon="icon-cog">
      <MenuItem
        text="Edit"
        onClick={() => history.push(`/products/cdn/${props.params.cdnId}/settings/edit`)} />
      <MenuItem
        text="Manage Cache"
        onClick={() => history.push(`/products/cdn/${props.params.cdnId}/settings/manage_cache`)} />
      <MenuItem
        text="SSL"
        onClick={() => {}} />
      {
        // <MenuItem
        //   text='Security'
        //   onClick={() => {}}
        // />
      }
      {
        // <MenuItem
        //   text='EdgeRules'
        //   onClick={() => {}}
        // />
      }
    </BrowserMenu>
  );

  const customResolver = (key, text, routePath, route) => {
    if (text.toLowerCase() === props.subsection.toLowerCase()) {
      return null;
    }

    if (key === ':cdnId') {
      if (props.CDNServiceCurrentSiteData) {
        return props.CDNServiceCurrentSiteData.domains[0];
      }
      return '...';
    }

    return key;
  };

  const defaultSeparator = (crumbElement, index, array) => <span key={`separator-${index}`}>/</span>;

  const crumbResolver = combineResolvers(customResolver, textResolver);


  let content = props.children;
  if (!content && !props.hideMenus) {
    content = (
      <div>
        <BrowserToolbarButton icon="icon-info" name="Summary" onClick={() => history.push(`/products/cdn/${props.params.cdnId}/overview`)} />
        {REPORTS}
        {SETTINGS}
      </div>
    );
  }

  return (
    <Toolbar
      section={<Breadcrumbs routes={props.routes} params={props.params} createSeparator={defaultSeparator} resolver={customResolver} />}
      subsection={props.subsection}>
      {content}
    </Toolbar>
  );
};

export default CDNSiteToolbar;
